// extracted by mini-css-extract-plugin
export default {"sidebar":"styles_sidebar__aKmn+","sidebarContracted":"styles_sidebarContracted__iTyVv","container":"styles_container__71kWy","link":"styles_link__Q8drk","flex":"styles_flex__yUczL"};